import React from "react";
import PropTypes from "prop-types";
import Card from "./Card";
import Image from "../ImageElement";
import ChevronRight from "../../svg/ICON_chevronRight_Dark.svg";
import "../../css/Cards/CardPerformance.css";

/**
 * CardPerformance component
 */
class CardPerformance extends React.Component {
  static displayName = "CardPerformance";
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    image: PropTypes.node.isRequired,
    files: PropTypes.object,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardPerformance";
  }

  componentDidMount() {
    if (this.props.location.hash === "#Performances") {
      setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 1);
    }
  }

  /**
   * @override
   */
  render() {
    return (
      <Card
        {...this.props}
        className={`${this.className} full ${this.props.className || ""}`}
      >
        <div className="Card__content">
          <div className="Card__img">
            <Image src={this.props.image} alt="Empty" />
          </div>
          <div className="Card__text">
            <div className="Card__html">
              {this.props.files.map((file) => {
                return (
                  <a
                    href={file.file().url}
                    rel="noopener noreferrer"
                    target="_blank"
                    className={`${this.className}__link`}
                    key={file.ID}
                  >
                    <img src={ChevronRight} alt=">" className="icon" />
                    {file.Label}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

export default CardPerformance;



// WEBPACK FOOTER //
// ./src/components/Cards/CardPerformance.js